import { MDBCard, MDBCol, MDBIcon, MDBRow } from 'mdbreact';

import CheckboxesAccordion from './checkbox/checkboxesaccordion';
import FindLocation from './flfield';
import React from 'react';
import styled from 'styled-components';

const SelectComp = styled.select`
  :focus{
    border-color: #ee1C25!important;
    box-shadow: 0 0 0 0.2rem #ffc3c3!important;
  }
`;

const Filter = (props) => {
  return (
    <MDBRow center>
      <MDBCol xs="12" md="12" lg="12" id={`filtering`}>
        <MDBCard className="my-2 py-2 px-3">
          <MDBRow>
            <MDBCol xs="12" sm="12" md="12" lg="2" className="col-12 py-3 text-center">
              <MDBIcon icon="fas fa-map-marked-alt" size="3x" className="red-text-Genesis" />
            </MDBCol>
            <MDBCol xs="12" sm="12" md="12" lg="3" className="col-12 p-10">
              <label id="SearchTypeLabel" htmlFor="SearchType" className="red-text-Genesis">Search by</label>
              <SelectComp 
                label="SearchType"
                id="SearchType"
                outline size="sm"
                className="form-control"
                value={props.searchtype} 
                onChange={(e) => props.handleSearchtypeChange(e.target.value)}>
                <option value="namecenter">Center Name</option>
                <option value="location">City/State/Zip</option>
              </SelectComp>
            </MDBCol>
            <MDBCol xs="12" sm="12" md="12" lg="5" className="col-12 p-10">
              <FindLocation 
                //  Drupal data
                locations={props.locations}     
                //  state values
                searchtype={props.searchtype}
                placeholderAddress={props.placeholderAddress}
                placeholderCName={props.placeholderCName}
                //  handlers
                handleACupdate={props.handleACupdate}
                handleCentersNames={props.handleCentersNames}
                handleCL={props.handleCL}
                handleCN={props.handleCN}/>
            </MDBCol>
            <MDBCol xs="12" sm="12" md="12" lg="2" className="col-12 p-10">
              <label htmlFor="radius" className="red-text-Genesis text-nowrap">within a radius of</label>
              <SelectComp 
                  label="radius"
                  id="radius"
                  outline size="sm"
                  className="form-control"
                  value={props.radius} 
                  onChange={(e) => props.handleRadiusChange(e.target.value)}>
                    <option value="10">10 Miles</option>
                    <option value="25">25 Miles</option>
                    <option value="50">50 Miles</option>
                    <option value="75">75 Miles</option>
                    <option value="100">100 Miles</option>
                    <option value="150000">Show All</option>
              </SelectComp>
            </MDBCol>
            <MDBCol xs="12" md="12" lg="12" sm="12" className="col-12 py-3 text-center">
              <CheckboxesAccordion 
                //  Drupal data
                featuredServices={props.featuredServices}    
                //  state values
                checkedItems={props.checkedItems}
                //  handlers
                handleCheckboxesChange={props.handleCheckboxesChange} />
            </MDBCol>
          </MDBRow>
        </MDBCard>
      </MDBCol>
    </MDBRow>   
  )
}

export default Filter